export { ExtraDetails } from './ExtraDetails';
